import { createSlice } from "@reduxjs/toolkit";

const initialProductCatalogState = {
  listLoading: false,
  actionsLoading: false,
  error: null,
};

export const callTypes = {
  list: "list",
  action: "action",
  download: "download"
};

export const productCatalogSlice = createSlice({
  name: "productCatalog",
  initialState: initialProductCatalogState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    catalogDownloaded: (state) => {
      state.error = null;
      state.actionsLoading = false;
    }
  }
});
